import { lighten, darken, toHex, parseToRgba } from 'color2k';
// Key represents the level and the initial value mapping - how lightness should change
// to get from one level to another.
const schema = {
    1: { 2: -2 },
    2: { 3: -5 },
    3: { 4: -10 },
    4: { 5: -10 },
    5: { 6: -20 },
    6: { 7: -10 },
    7: { 8: -15 },
    8: {},
};
function extendSchema() {
    for (let level = 1; level <= 8; level++) {
        for (let levelTo = 1; levelTo <= 8; levelTo++) {
            if (levelTo === level) {
                schema[level][level] = 0;
                continue;
            }
            if (levelTo > level) {
                schema[level][levelTo] = schema[level][levelTo - 1] + schema[levelTo - 1][levelTo];
                continue;
            }
            if (levelTo < level) {
                schema[level][levelTo] = -schema[levelTo][level];
                continue;
            }
        }
    }
}
extendSchema();
// Generates a whole specter of colors for the theme colors.
export function transformColor(inputColor, inputLevel, outputLevel) {
    const lightnessStep = schema[inputLevel][outputLevel] / 100;
    if (lightnessStep > 0) {
        return toHex(lighten(inputColor, lightnessStep));
    }
    if (lightnessStep < 0) {
        return toHex(darken(inputColor, -lightnessStep));
    }
    return inputColor;
}
// Generates full spectre of colors for the theme colors.
export function generateThemeColors(color, prefix) {
    const defaultInputLevel = 6;
    const levelToColor = {};
    for (let level = 1; level <= 8; level++) {
        levelToColor[`${prefix}${level}`] = transformColor(color, defaultInputLevel, level);
    }
    return levelToColor;
}
/**
 * If color2k fails to recognize the color, the idea is simple: catch the error and state that
 * the argument is invalid. Unfortunately, color2k does not have the validation function, so we
 * have to resolve this hack. The getter function is chosen intentionally
 * as it is potentially less expensive.
 */
export function isValidColor(color) {
    try {
        parseToRgba(color);
        return true;
    }
    catch (_) {
        return false;
    }
}
//# sourceMappingURL=color.js.map